import React from "react";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import { isFiledInboxEmail, isUnverifiedInboxEmail } from "@seabrookstudios/pitch2table-core";

/**
 * @param {string | null | undefined} from
 * @returns {string}
 */
const unverifiedSenderWarningText = (from) => {
  const address = `${from || ""}`.trim() || "Unknown sender";
  return `We couldn't verify this sender (${address}). Be careful with links and attachments.`;
};

/**
 * @param {object} props
 * @param {Pick<import("@seabrookstudios/pitch2table-core").InboundEmail, "senderVerified" | "from" | "classification">} props.message
 * @returns {React.JSX.Element|null}
 */
export const UnverifiedSenderWarning = ({ message }) => {
  if (!isUnverifiedInboxEmail(message)) {
    return null;
  }

  if (isFiledInboxEmail(message)) {
    return (
      <Typography variant="body2" color="text.secondary">
        Sender not verified
      </Typography>
    );
  }

  return <Alert severity="warning">{unverifiedSenderWarningText(message.from)}</Alert>;
};
